// =====Modules=======
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routing } from '../app.routes';
import { SharedModule } from './../shared/shared.module';
import { AccountInformationComponent } from './account-information.component';
import { EmailSentDialogComponent } from './email-sent-dialog/email-sent-dialog.component';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './i18n/', '.json');
  }

@NgModule({
    imports: [
        TranslateModule.forRoot({
            loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
            }
          }),
        CommonModule,
        FormsModule,
        SharedModule,
        routing
    ],
    declarations: [
        AccountInformationComponent,
        EmailSentDialogComponent
    ],
    exports: [
        AccountInformationComponent
    ],
    schemas : [CUSTOM_ELEMENTS_SCHEMA]
})

export class AccountInformationModule { }
